export default {"src":"/_next/static/media/white-square-meters.4fcdb7ad.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};